import script from "./NewsListPage.vue?vue&type=script&lang=js"
export * from "./NewsListPage.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__